import axios from "axios";

export const createResetPasswordToken = (body) => {
  return axios.post("/api/1.0/reset-password-tokens", body);
};

export const getResetPasswordToken = (token) => {
  return axios.get(`/api/1.0/reset-password-tokens/${token}`);
};
